export default "__VITE_ASSET__Cfh2s_S9__"